import React from "react";
import ServiceCard from "./ServiceCard";
import "./ServiceCard.css";

function ServiceCardWrap() {
  return (
    <section className="services-grid">
      <div className="container">
        <div className="title-wrap">
          <div className="sec-title">
            <span className="wow animate fadeInUp">Elevate Your Presence</span>
            <h2 className="wow animate fadeInUp" data-wow-delay="200ms">Digital Excellence</h2>
            <p className="wow animate fadeInUp" data-wow-delay="300ms">
              We build high-intensity design and content solutions tailored for 
              rapid growth and maximum global impact.
            </p>
          </div>
        </div>
        <div className="row g-5">
          {/* Service 1: Creative Production with Video */}
          <div className="col-md-6 col-lg-4 wow animate fadeInUp" data-wow-delay="200ms">
            <ServiceCard
              serviceNumber="01"
              image="/img/icons/service-icon-1.png"
              title="Creative Direction"
              details="Crafting high-octane video edits and brand identities that demand attention. We turn your product vision into a visual powerhouse."
              video="https://cdn.dlplatforms.com/sample/sample01.mp4"
            />
          </div>

          {/* Service 2: Content Scaling with Video */}
          <div className="col-md-6 col-lg-4 wow animate fadeInUp" data-wow-delay="300ms">
            <ServiceCard
              serviceNumber="02"
              image="/img/icons/service-icon-5.png"
              title="Content Refinement"
              details="Optimizing your assets for maximum engagement. We transform raw footage into 12+ punchy clips for TikTok, Reels, and Shorts."
              video="https://cdn.dlplatforms.com/sample/sample04.mp4"
            />
          </div>

          {/* Service 3: Design with Video */}
          <div className="col-md-6 col-lg-4 wow animate fadeInUp" data-wow-delay="400ms">
            <ServiceCard
              serviceNumber="03"
              image="/img/icons/service-icon-6.png"
              title="Strategic Growth"
              details="Implementing data-driven strategies that ensure sustainable user acquisition and long-term brand authority."
              video="https://cdn.dlplatforms.com/sample/sample02.mp4"
            />
          </div>

          {/* Service 4: Data & AI */}
          <div className="col-md-6 col-lg-4 wow animate fadeInUp" data-wow-delay="500ms">
            <ServiceCard
              serviceNumber="04"
              image="/img/icons/service-icon-3.png"
              title="Data Systems"
              details="Automating your workflow with custom AI solutions and robust data engineering built for high-performance teams."
            />
          </div>

          {/* Service 5: Team Support */}
          <div className="col-md-6 col-lg-4 wow animate fadeInUp" data-wow-delay="600ms">
            <ServiceCard
              serviceNumber="05"
              image="/img/icons/service-icon-2.png"
              title="Team Augmentation"
              details="Strategic design and dev support that scales with you. Our experts integrate seamlessly with your core business operations."
            />
          </div>

          {/* Service 6: Special Ops */}
          <div className="col-md-6 col-lg-4 wow animate fadeInUp" data-wow-delay="700ms">
            <ServiceCard
              serviceNumber="06"
              image="/img/icons/feature-icon-4.png"
              title="UI/UX Engineering"
              details="Building intuitive digital experiences that convert. We focus on scalable design systems and premium user interfaces."
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceCardWrap;
